<style lang="scss">
.zoezi-news-list{
    .zoezi-news-items{
        margin: 0 -10px;
        display:flex;
        flex-wrap: wrap;
        .zoezi-news-card{
            position:relative;
            margin: 10px;
            width:calc(100% - 20px);
            transition:all 250ms ease-in-out;
            &:before{
                display:none;
            }
            .no-image-title{
                background:#eee;
                color:white;
                text-align:center;
                padding-bottom: 66.667%;
                position:relative;
                font-size:30px;
                text-shadow:0 0 20px rgba(0,0,0,.05);
                overflow:hidden;
                >div{
                    position:absolute;
                    top: 50%;
                    width:100%;
                    margin-top:-1em;
                }
            }
            .v-image{

            }
            .v-card__text{
                .zoezi-news-title{
                    margin-bottom:12px;
                }
                .zoezi-news-content{
                    position:relative;
                    height: 5em;
                    max-height: 5em;
                    min-height: 5em;
                    margin-bottom: 12px;
                    overflow:hidden;
                    transition: all 250ms ease-in-out;
                    &:after{
                        transition:all 250ms ease-in-out;
                        pointer-events:none;
                        content: '';
                        display:block; position:absolute;
                        left:0; top:2em; right:0; height: 3em;
                        background: linear-gradient(
                            180deg,
                            rgba(255,255,255,0) 0%,
                            rgba(255,255,255,1) 100%
                        );
                    }
                    h1,h2,h3{margin-bottom:.5em;}
                    h1{font-size: 1.33em}
                    h2{font-size: 1.25em}
                    h3{font-size: 1.125em}
                }
                .zoezi-date, .zoezi-author{
                    font-size: 12px;
                    color:#999;
                    margin-right: 10px;
                    .v-icon{
                        margin-right: 5px;
                    }
                }
            }

            @media(min-width:600px){
                width: calc(50% - 20px);
                &:nth-child(-n+2){
                    width: calc(100% - 20px);
                }
            }

            @media(min-width:960px){
                width: calc(33.333% - 20px);
                &:nth-child(-n+2){
                    width: calc(50% - 20px);
                }
            }

            @media(min-width:1200px){
                width: calc(25% - 20px);
                &:nth-child(-n+2){
                    width: calc(50% - 20px);
                }
            }
        }
        &.zoezi-news-blog {
            margin: 0;
            .zoezi-news-card {
                width: 100% !important;
                margin: 10px 0;
                cursor:text;
                .v-image {
                    max-height: 90vh;
                }
                .v-card__text {
                    .zoezi-news-content {
                        max-height: none;
                        overflow: visible;
                        height: auto;
                        min-height: 0;
                        &:after {
                            display: none;
                        }
                    }
                }
                @media(min-width:600px) {
                    .zoezi-news-title{
                        font-size: 3em;
                        line-height: 1.2;
                    }
                    .v-image + .v-card__text {
                        display: flex;
                        justify-content: space-between;
                        flex-wrap: wrap;
                        .zoezi-news-content {
                            padding-left: 16px;
                            font-size: 1.125em;
                            line-height: 1.5;
                            max-width: 550px;
                            flex-shrink: 1;
                            & + div {
                                flex-shrink: 0;
                                padding-left: 15px;
                            }
                        }
                        .zoezi-news-title {
                            max-width: 550px;
                            margin-right: calc(100% - 550px);
                            margin-top: -1.75em;
                            padding: 8px 16px;
                            border-top-left-radius: 5px;
                            border-top-right-radius: 5px;
                            background: rgba(255, 255, 255, .8);
                            backdrop-filter: blur(5px);
                            position: relative;
                        }
                        &.no-addon {
                            display:block;
                            .zoezi-news-content {
                                margin-left: auto;
                                margin-right:auto;
                            }
                            .zoezi-news-title {
                                margin-left:auto;
                                margin-right:auto;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
<template>
    <v-card :tile="flat" :flat="flat" @click="toggleCard" :ripple="false" :to="to">
        <v-auto-img v-if="item.imagekey" :src="item.imagekey" :ar="3/2" />
        <div v-if="!item.imagekey && !blogStyle" class="no-image-title">
            <div>{{item.title}}</div>
        </div>
        <v-card-text :class="{'no-addon' : (!showDate && !showAuthor)}">
            <h2 class="zoezi-news-title">{{item.title}}</h2>
            <div v-html="item.content" class="zoezi-news-content"></div>
            <div v-if="showDate || showAuthor">
                <span v-if="showDate" class="zoezi-date"><v-icon small>mdi-clock-outline</v-icon>{{date}}</span>
                <span v-if="showAuthor && item.author" class="zoezi-author"><v-icon small>mdi-account</v-icon>{{item.author.firstname}} {{item.author.lastname}}</span>
            </div>
            <div class="d-flex mt-2" v-if="hasPostPermission">
                <div class="z-clickable primary--text" @click="editArticle = true">
                    {{$translate('Edit the post')}}
                </div>
                <v-spacer />
                <div class="z-clickable error--text" @click="remove(item)">
                    {{$translate('Remove the post')}}
                </div>
            </div>
            <news-compose :news-item="item" v-if="editArticle" @close="editArticle = false" />
        </v-card-text>
    </v-card>
</template>

<script>
import NewsCompose from '../components/NewsCompose.vue'
export default {

    name: 'zoezi-news-card',
    components: {
        NewsCompose
    },
    props: ['item', 'showDate', 'showAuthor', 'flat', 'blogStyle', 'to'],
    methods: {
        toggleCard(){
            if(!this.blogStyle && !this.$root.edit){
                let item = this.item;
                this.$emit('clicked', item);
            }
        },
        remove(item) {
            this.$store.commit('showConfirmDialog', {
                title: this.$translate('Remove post'),
                text: this.$translate('Are you sure you want to remove the post?'),
                actionText: this.$translate('Remove'),
                action: () => {
                    this.$api.post('/api/news/item/remove', null, {id: item.id}).then(() => {
                        this.currentArticle = null;
                    })
                }
            });
        },
    },
    computed: {
        date() {
            return Date.formatFullShort(this.item.published);
        },
        hasPostPermission() {
            return this.$store.state?.user?.permissions?.find(x => x == 'Mailing handling');
        },
    },
    data: () => ({
        editArticle: false
    })
}
</script>
